import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWhiteStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.95944 5.91C7.82994 6.0355 7.77044 6.217 7.79994 6.395L8.24444 8.855C8.28194 9.0635 8.19394 9.2745 8.01944 9.395C7.84844 9.52 7.62094 9.535 7.43444 9.435L5.21994 8.28C5.14294 8.239 5.05744 8.217 4.96994 8.2145H4.83444C4.78744 8.2215 4.74144 8.2365 4.69944 8.2595L2.48444 9.42C2.37494 9.475 2.25094 9.4945 2.12944 9.475C1.83344 9.419 1.63594 9.137 1.68444 8.8395L2.12944 6.3795C2.15894 6.2 2.09944 6.0175 1.96994 5.89L0.164438 4.14C0.0134379 3.9935 -0.0390621 3.7735 0.0299379 3.575C0.0969379 3.377 0.267938 3.2325 0.474438 3.2L2.95944 2.8395C3.14844 2.82 3.31444 2.705 3.39944 2.535L4.49444 0.29C4.52044 0.24 4.55394 0.194 4.59444 0.155L4.63944 0.12C4.66294 0.094 4.68994 0.0725 4.71994 0.055L4.77444 0.035L4.85944 0H5.06994C5.25794 0.0195 5.42344 0.132 5.50994 0.3L6.61944 2.535C6.69944 2.6985 6.85494 2.812 7.03444 2.8395L9.51944 3.2C9.72944 3.23 9.90494 3.375 9.97444 3.575C10.0399 3.7755 9.98344 3.9955 9.82944 4.14L7.95944 5.91Z",
		fill: "white"
	})
});
export default SvgWhiteStar;
